export const PROCESS_DONATION = "PROCESS_DONATION"
export const UPDATE_DONATION_FREQUENCY = "UPDATE_DONATION_FREQUENCY"
export const UPDATE_DONATION_ORGANIZATION = "UPDATE_DONATION_ORGANIZATION"
export const UPDATE_DONATION_AMOUNT = "UPDATE_DONATION_AMOUNT"
export const UPDATE_DONATION_GIVING_REASON_TYPE = "UPDATE_DONATION_GIVING_REASON_TYPE"
export const UPDATE_DONATION_GIVING_REASON_VALUE = "UPDATE_DONATION_GIVING_REASON_VALUE"
export const UPDATE_DONATION_GIVING_REASON_DETAIL = "UPDATE_DONATION_GIVING_REASON_DETAIL"
export const UPDATE_DONATION_AMOUNT_ERROR = "UPDATE_DONATION_AMOUNT_ERROR"
export const UPDATE_DONATION_CLASS_YEAR = "UPDATE_DONATION_CLASS_YEAR"
export const UPDATE_DONATION_ORGANIZATION_ERROR = "UPDATE_DONATION_ORGANIZATION_ERROR"
export const FETCH_DONATION_HISTORY = "FETCH_DONATION_HISTORY"
export const RECEIVE_DONATION_HISTORY = "RECEIVE_DONATION_HISTORY"
export const UPDATE_DONATE_ON_HISTORY_OPEN = "UPDATE_DONATE_ON_HISTORY_OPEN"
export const PROCESS_DONATION_SESSION = "PROCESS_DONATION_SESSION"
export const RECEIVE_DONATION_SESSION_ID = "RECEIVE_DONATION_SESSION_ID"
export const CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION"

export const processDonation = (payload, success, error) => ({
  type: PROCESS_DONATION,
  payload,
  success,
  error,
})
export const processDonationSession = (payload, success, error) => ({
  type: PROCESS_DONATION_SESSION,
  payload,
  success,
  error,
})

export const receiveDonationSessionId = ({ id }, success, error) => ({
  type: RECEIVE_DONATION_SESSION_ID,
  sessionId: id,
  success,
  error,
})

export const updateDonationFrequency = (interval) => ({
  type: UPDATE_DONATION_FREQUENCY,
  interval,
})

export const updateDonationOrganization = (organization) => ({
  type: UPDATE_DONATION_ORGANIZATION,
  organization,
})

export const updateDonationClassYear = (classYear) => ({
  type: UPDATE_DONATION_CLASS_YEAR,
  classYear,
})

export const updateDonationAmount = (amount) => ({
  type: UPDATE_DONATION_AMOUNT,
  amount,
})

export const updateDonationAmountError = (amountError) => ({
  type: UPDATE_DONATION_AMOUNT_ERROR,
  amountError,
})

export const updateDonationOrganizationError = (organziationError) => ({
  type: UPDATE_DONATION_ORGANIZATION_ERROR,
  organziationError,
})

export const updateDonationGivingReasonType = (givingReasonType) => ({
  type: UPDATE_DONATION_GIVING_REASON_TYPE,
  givingReasonType,
})

export const updateDonationGivingReasonValue = (givingReasonValue) => ({
  type: UPDATE_DONATION_GIVING_REASON_VALUE,
  givingReasonValue,
})

export const updateDonationGivingReasonDetail = (givingReasonDetail) => ({
  type: UPDATE_DONATION_GIVING_REASON_DETAIL,
  givingReasonDetail,
})

export const fetchDonationHistory = (success) => ({
  type: FETCH_DONATION_HISTORY,
  success,
})

export const receiveDonationHistory = (donations, success, error) => ({
  type: RECEIVE_DONATION_HISTORY,
  donations,
  success,
  error,
})

export const updateDonateOnHistoryOpen = (open) => ({
  type: UPDATE_DONATE_ON_HISTORY_OPEN,
  open,
})

export const cancelSubscription = (subscriptionId, success, error) => ({
  type: CANCEL_SUBSCRIPTION,
  subscriptionId,
  success,
  error,
})
